import { CommunityPartner, CommunityPartnersResponse } from '@/types';
import { apiSlice } from './apiSlice';

export const upiApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCommunityPartners: builder.query<
      CommunityPartnersResponse,
      {
        search?: string;
        skip?: number;
        take?: number;
      }
    >({
      query: ({ search, skip = 0, take = 10 }) => ({
        url: '/community-partners',
        params: {
          search,
          skip,
          take,
        },
      }),
      providesTags: ['CommunityPartners'],
    }),

    deleteCommunityPartner: builder.mutation<void, number>({
      query: (id) => ({
        url: `/community-partners/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CommunityPartners'],
    }),

    createCommunityPartner: builder.mutation({
      query: (body) => ({
        url: '/community-partners',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CommunityPartners'],
    }),
  }),
});

export const {
  useGetCommunityPartnersQuery,
  useDeleteCommunityPartnerMutation,
  useCreateCommunityPartnerMutation,
} = upiApi;
